const routers: any[] = [
	{
		title: '活动微站',
		path: '/',
		name: 'home',
		meta: {
			// keepAlive: true,// 是否需要开启页面缓存
			wechatAuth: true, // 是否开启微信授权
			closeMonitorView: true // 是否关闭页面浏览监测，自定义页面标题使用
		},
		component: () => import(/* webpackChunkName: "home" */ '@/views/home.vue')
	},
	{
		title: '活动微站',
		path: '/details',
		name: 'details',
		meta: {
			// keepAlive: true,// 是否需要开启页面缓存
			wechatAuth: true, // 是否开启微信授权
			closeMonitorView: true // 是否关闭页面浏览监测，自定义页面标题使用
		},
		component: () => import('@/views/details.vue')
	},
	{
		title: '活动微站',
		path: '/search',
		name: 'search',
		meta: {
			// keepAlive: true,// 是否需要开启页面缓存
			wechatAuth: true, // 是否开启微信授权
			closeMonitorView: true // 是否关闭页面浏览监测，自定义页面标题使用
		},
		component: () => import('@/views/search.vue')
	},
	{
		title: '活动微站',
		path: '/video',
		name: 'video',
		meta: {
			// keepAlive: true,// 是否需要开启页面缓存
			wechatAuth: true, // 是否开启微信授权
			closeMonitorView: true // 是否关闭页面浏览监测，自定义页面标题使用
		},
		component: () => import('@/views/video.vue')
	},
	{
		title: '活动微站',
		path: '/pdf',
		name: 'pdf',
		meta: {
			// keepAlive: true,// 是否需要开启页面缓存
			wechatAuth: true, // 是否开启微信授权
			closeMonitorView: true // 是否关闭页面浏览监测，自定义页面标题使用
		},
		component: () => import('@/views/pdf.vue')
	}
];

export default routers;
